export function printNode(node) {
  const win = window.open("", "_blank", "noopener,noreferrer,width=800,height=900");
  if (!win) return;
  const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style')).map(el => el.outerHTML).join("\n");
  win.document.write(`<!doctype html><html><head>${styles}<style>@page{margin:16mm}</style></head><body>${node.cloneNode(true).outerHTML}</body></html>`);
  win.document.close(); win.focus(); setTimeout(() => { win.print(); win.close(); }, 300);
}
